import React, { useState } from "react";
import styles from "./DownloadApp.module.css";
import Button from "assets/svg/Button.svg";
import Modal from "components/common/Modal";
import { fnLink } from "function/fnLink";

const ready = process.env.PUBLIC_URL + "/svg/ready.svg";

export default function DownloadApp() {
    const [isModalOpen, setIsModalOpen] = useState(false);
    return (
        <div className={styles.downloadApp}>
            <div className={styles.text3}>똑똑하게 주차하기, <span className={styles.highlight}>준비 됐나요?</span></div>
            <div className={styles.text4}>앱을 지금 다운로드하고</div>
            <div className={styles.text4} style={{ marginBottom: "40px" }}>AI 주차를 직접 경험해보세요</div>
            <img className={styles.downloadBtn} src={Button} alt="downloadLink" onClick={fnLink} />
            {/* ✅ 공용 모달 사용 */}
            <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
                <img src={ready} style={{ width: "48px" }} alt="ready" />
                <p>앱 출시가 얼마 남지 않았어요!</p>
                <p>기대해 주세요 🚗</p>
            </Modal>
        </div>
    );
};
